if (!customElements.get('variant-selects')) {
  customElements.define(
    'variant-selects',
    class VariantSelects extends HTMLElement {
      constructor() {
        super();
      }

      get selectedOptionValues() {
        return Array.from(this.querySelectorAll('select option[selected], fieldset input:checked')).map(
          ({ dataset }) => dataset.optionValueId
        );
      }

      getInputForEventTarget(target) {
        return target.tagName === 'SELECT' ? target.selectedOptions[0] : target;
      }

      connectedCallback() {
        this.addEventListener('change', (event) => {
          const target = this.getInputForEventTarget(event.target);

          const optionGroupName = target.dataset.optionName?.toLowerCase() || '';

          if (optionGroupName.includes('color')) {
            console.log('Color option group changed');
          }

          if (optionGroupName.includes('design')) {
            console.log('Design option group changed');
          }

          this.updateSelectedSwatchValue(event);

          FoxTheme.pubsub.publish(FoxTheme.pubsub.PUB_SUB_EVENTS.optionValueSelectionChange, {
            data: {
              event,
              target,
              selectedOptionValues: this.selectedOptionValues,
            },
          });
        });
      }

      updateSelectedSwatchValue({ target }) {
        const { value, tagName } = target;

        if (tagName === 'SELECT' && target.selectedOptions.length) {
          Array.from(target.options)
            .find((option) => option.getAttribute('selected'))
            ?.removeAttribute('selected');

          target.selectedOptions[0].setAttribute('selected', 'selected');

          const swatchValue = target.selectedOptions[0].dataset.optionSwatchValue;
          const selectedDropdownSwatchValue = target
            .closest('.product-form__input')
            .querySelector('[data-selected-value] > .swatch');
          if (!selectedDropdownSwatchValue) return;

          if (swatchValue) {
            selectedDropdownSwatchValue.style.setProperty('--swatch--background', swatchValue);
            selectedDropdownSwatchValue.classList.remove('swatch--unavailable');
          } else {
            selectedDropdownSwatchValue.style.setProperty('--swatch--background', 'unset');
            selectedDropdownSwatchValue.classList.add('swatch--unavailable');
          }

          selectedDropdownSwatchValue.style.setProperty(
            '--swatch-focal-point',
            target.selectedOptions[0].dataset.optionSwatchFocalPoint || 'unset'
          );
        } else if (tagName === 'INPUT' && target.type === 'radio') {
          const selectedSwatchValue = target.closest(`.product-form__input`).querySelector('[data-selected-value]');
          if (selectedSwatchValue) selectedSwatchValue.innerHTML = value;
        }
      }

      updateSelectedVariant(variantId) {
        const input = this.querySelector(`input[value="${variantId}"], select option[value="${variantId}"]`);
        if (!input) return;

        const inputElement = input.closest('select') || input;
        const event = new Event('change', { bubbles: true });
        inputElement.dispatchEvent(event);
      }
    }
  );
} // ✅ <<< this was missing — you MUST have this to close the if-block!

// ✅ GLOBAL THUMBNAIL CLICK LISTENER — now it will always run
window.addEventListener('load', () => {
  document.addEventListener('click', function (e) {
    const thumb = e.target.closest('[data-variant-id]');
    if (!thumb) return;

    const variantId = thumb.getAttribute('data-variant-id');
    if (!variantId) return;

    const variantSelect = document.querySelector('variant-selects');
    if (!variantSelect || typeof variantSelect.updateSelectedVariant !== 'function') {
      console.warn('VariantSelects not ready');
      return;
    }

    variantSelect.updateSelectedVariant(variantId);
  });
});
